import { FunctionService } from '../services';
import { alertConstants } from '../constants';
export const alertActions = {
    SendAlert
};
function SendAlert(text,type){
    return dispatch => {
        dispatch(FunctionService.succes({text:text,code:type},alertConstants.SEND_ALERT_DATA))
    }
}